(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_pivot-cart-drawer__boleta-factura"] && !Shopify.designMode) return;
  try {
    class PivotInvoiceForm extends HTMLElement {
    constructor() {
      super();

      this._state = {
        button: 'save',
        disabledButton: true,
        disabledMainButton: false,
      };

      const $regionsMappingNode = this.querySelector('#pivot-invoice-regions-mapping');
      this.$regionsMapping = $regionsMappingNode ? JSON.parse($regionsMappingNode.textContent) : {};

      this.$rutInput = this.querySelector('input[name="attributes[RUTEmpresa]"]');
      this.$regionSelector = this.querySelector('select[name="attributes[Region]"]');
      this.$communeSelector = this.querySelector('select[name="attributes[Comuna]"]');
      this.$form = this.querySelector('form.details-content');
      this.$label = this.querySelector('.cart-discount__label');
      this.$button = this.querySelector('button[type="submit"]');
      this.$clearButton = this.querySelector('#pivot-invoice-clear');
      this.$rutErrorMessage = this.querySelector('.rut-error-message');

      this.savedValues = {};
      this.hasSavedData = false;

      this.initEvents();
      this.initializeFormState();
    }

    getFormValues = () => {
      const data = Object.fromEntries(new FormData(this.$form));
      return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, (value || '').toString().trim()]));
    };

    hasAnyValue = (values) => {
      return Object.values(values).some((value) => value !== '');
    };

    isSameValues = (left, right) => {
      const keys = new Set([...Object.keys(left), ...Object.keys(right)]);
      return Array.from(keys).every((key) => (left[key] || '') === (right[key] || ''));
    };

    getValidationState = () => {
      const requiredInputs = Array.from(this.$form.querySelectorAll('input[required], select[required]'));
      const allRequiredFilled = requiredInputs.every((input) => input.value.trim() !== '');
      const rutValue = this.$rutInput ? this.$rutInput.value.trim() : '';
      const rutIsValid = rutValue === '' || validateRut(rutValue);
      const hasInvalid = !!this.$form.querySelector(':invalid') || !rutIsValid;

      return {
        allRequiredFilled,
        hasInvalid,
        isCompleteAndValid: allRequiredFilled && !hasInvalid,
      };
    };

    initializeFormState = () => {
      if (!this.$form || !this.$communeSelector) {
        return;
      }

      const communeValue = this.$communeSelector.dataset.value || '';
      this.handleRegionChange(communeValue);

      if (communeValue) {
        this.$communeSelector.value = communeValue;
      }

      this.savedValues = this.getFormValues();
      this.hasSavedData = this.getValidationState().isCompleteAndValid && this.hasAnyValue(this.savedValues);
      this.checkFormState();
    };

    onStateChange = () => {
      this.$button = this.querySelector('button[type="submit"]');
      this.$clearButton = this.querySelector('#pivot-invoice-clear');
      // Find all checkout buttons on the page (covers main-cart, cart-drawer and other placements)
      this.$mainButtons = Array.from(
        document.querySelectorAll("button[name='checkout'], input[name='checkout']")
      ).filter(Boolean);

      if (!this.$button || !this.$clearButton) {
        return;
      }

      this.$button.disabled = this._state.disabledButton;
      this.$clearButton.disabled = this._state.button !== 'clear';

      if (this.$mainButtons && this.$mainButtons.length) {
        this.$mainButtons.forEach((btn) => (btn.disabled = this._state.disabledMainButton));
      }

      if (this._state.button === 'save') {
        this.$button.style.display = 'block';
        this.$clearButton.style.display = 'none';
      } else {
        this.$button.style.display = 'none';
        this.$clearButton.style.display = 'block';
      }
    };

    initEvents = () => {
      if (!this.$form || !this.$regionSelector || !this.$communeSelector || !this.$rutInput || !this.$clearButton) {
        return;
      }

      this.$regionSelector.addEventListener('change', this.handleRegionChange);
      this.$rutInput.addEventListener('keyup', this.handleRutChange);
      this.$rutInput.addEventListener('blur', this.handleRutChange);
      this.$form.addEventListener('submit', this.handleSubmit);
      this.$clearButton.addEventListener('click', this.handleClear);

      this.$form.addEventListener('input', this.checkFormState);
      this.$form.addEventListener('change', this.checkFormState);
    };

    checkFormState = () => {
      if (!this.$form) {
        return;
      }

      const currentValues = this.getFormValues();
      const { isCompleteAndValid } = this.getValidationState();
      const isDirty = !this.isSameValues(currentValues, this.savedValues);

      if (this.hasSavedData && !isDirty) {
        this._state.button = 'clear';
        this._state.disabledButton = false;
      } else {
        this._state.button = 'save';
        this._state.disabledButton = !isCompleteAndValid;
      }

      this._state.disabledMainButton = isDirty;
      this.onStateChange();
    };

    handleRegionChange = (preferredCommune = '') => {
      const region = this.$regionSelector.value;
      const communes = this.$regionsMapping[region] || [];
      const currentValue = preferredCommune || this.$communeSelector.value;

      this.$communeSelector.innerHTML =
        `<option value="">Selecciona una comuna</option>` +
        communes.map((commune) => `<option value="${commune}">${commune}</option>`).join('');

      if (currentValue && communes.includes(currentValue)) {
        this.$communeSelector.value = currentValue;
      } else {
        this.$communeSelector.value = '';
      }

      this.checkFormState();
    };

    handleRutChange = () => {
      const $errorMessage = this.querySelector('.rut-error-message');

      if (this.$rutInput.value == '' || validateRut(this.$rutInput.value)) {
        this.$rutInput.setCustomValidity('');
        this.$rutInput.value = formatDNI({ rut: this.$rutInput.value, pais: 'CL' });
        $errorMessage.classList.remove('show');
      } else {
        // this.$rutInput.value = '';
        this.$rutInput.setCustomValidity('Ingresa un RUT válido');
        // Mostrar mensaje de error sin llevar el foco
        $errorMessage.classList.add('show');
      }

      // Actualizar el estado del formulario después de validar el RUT
      this.checkFormState();
    };

    handleSubmit = (e) => {
      e.preventDefault();

      // Verificar si el RUT es válido antes de enviar
      if (this.$rutInput.value && !validateRut(this.$rutInput.value)) {
        this.$rutErrorMessage.classList.add('show');
        this.checkFormState();
        return;
      }

      const data = Object.fromEntries(new FormData(e.target));
      this.$button.disabled = true;
      this.$button.textContent = 'Guardando...';
      this.$clearButton.disabled = true;

      fetch('/cart/update.js', {
        method: 'POST',
        body: new FormData(e.target),
      })
        .then(() => {
          if (data['attributes[RUTEmpresa]'] && data['attributes[RazonSocial]']) {
            this.$label.innerHTML = `<div><span class="pvt-invoicing-label">Factura:</span> ${data['attributes[RazonSocial]']} - ${data['attributes[RUTEmpresa]']}</div>`;
          } else {
            this.$label.textContent = '';
          }

          this.savedValues = this.getFormValues();
          this.hasSavedData = this.getValidationState().isCompleteAndValid && this.hasAnyValue(this.savedValues);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.$button.textContent = 'Guardar';
          this.checkFormState();
        });
    };

    handleClear = () => {
      const attributes = {
        RUTEmpresa: null,
        RazonSocial: null,
        Giro: null,
        DireccionEmpresa: null,
        Region: null,
        Comuna: null,
      };
      // Ocultar mensaje de error al limpiar
      this.$rutErrorMessage.classList.remove('show');
      this.$clearButton.disabled = true;
      this.$clearButton.textContent = 'Limpiando...';
      this.$button.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({ attributes }),
      })
        .then(() => {
          this.querySelectorAll('input,select').forEach((el) => (el.value = ''));
          this.handleRegionChange();
          this.$label.textContent = '¿Necesitas factura?';
          this.savedValues = this.getFormValues();
          this.hasSavedData = false;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.$button.textContent = 'Guardar';
          this.$clearButton.textContent = 'Limpiar';
          this.checkFormState();
        });
    };
  }

  if (!customElements.get('pivot-invoice-form')) {
    customElements.define('pivot-invoice-form', PivotInvoiceForm);
  }

  const byCountry = {
    cl: function ({ rut }) {
      const regex = /[^\dkK]/g;

      rut = rut.toString().replace(regex, '');
      const dv = rut.slice(-1).toUpperCase();
      if (rut && dv) {
        rut = rut.slice(0, -1) + '-' + dv;
      }
      return rut;
    },
  };

  function formatDNI({ rut, pais, tipo }) {
    return byCountry[pais?.toLowerCase()]?.({ rut, tipo }) || rut;
  }

  function validateRut(rut) {
    rut = rut.replace(/[^0-9kK]/g, ''); // Eliminar todos los caracteres no numéricos excepto la 'k' o 'K'
    if (rut.length < 8 || rut.length > 9) {
      return false;
    } // El RUT debe tener al menos 2 caracteres (cuerpo + dígito verificador)
    console.log(rut);
    let cuerpo = rut.slice(0, -1); // Obtener el cuerpo del RUT (sin el dígito verificador)
    console.log(cuerpo);
    let dv = rut.slice(-1).toUpperCase(); // Obtener el dígito verificador (puede ser 'k' o 'K' en mayúsculas)

    let suma = cuerpo
      .split('')
      .reverse()
      .reduce((acc, digit, index) => acc + parseInt(digit) * ((index % 6) + 2), 0);

    let resultado = 11 - (suma % 11); // Calcular el dígito verificador esperado
    console.log(resultado);
    let digitoVerificador = resultado === 11 ? '0' : resultado === 10 ? 'K' : resultado.toString();
    console.log(digitoVerificador);
    return dv == digitoVerificador;
  }
  } catch(e) { console.error(e); }
})();

})();
